import { supabase } from "@/integrations/supabase/client";

type SupabaseRuntimeClient = typeof supabase & {
  supabaseUrl?: string;
  supabaseKey?: string;
};

const getProjectRefFromUrl = (value?: string) => {
  try {
    return value ? new URL(value).hostname.split(".")[0] ?? "" : "";
  } catch {
    return "";
  }
};

/**
 * Storage / TUS / direct REST calls MUST target the same Supabase project
 * the auto-generated client (`src/integrations/supabase/client.ts`) is wired
 * to. Routing storage to a different project than auth/RPC/edge functions
 * causes a split-brain: the file lands in project A while edge functions
 * (e.g. finalize-anonymous-upload) run in project B and cannot see it.
 */
export const getSupabaseRuntimeConfig = () => {
  const runtimeClient = supabase as unknown as SupabaseRuntimeClient;
  const supabaseUrl = runtimeClient.supabaseUrl ?? "";
  const supabaseKey = runtimeClient.supabaseKey ?? "";

  if (!supabaseUrl || !supabaseKey) {
    throw new Error("Configurazione backend non disponibile.");
  }

  const projectId = getProjectRefFromUrl(supabaseUrl);
  return { supabaseUrl, supabaseKey, projectId };
};

export const getSupabaseFunctionUrl = (functionName: string) => {
  const { supabaseUrl } = getSupabaseRuntimeConfig();
  return `${supabaseUrl}/functions/v1/${functionName}`;
};